















































































































































































































































import { Component } from "vue-property-decorator";
import CertificateEdit from './CertificateEdit';
import CertificateContactEdit from './CertificateContactEdit.vue';
import EventCard from "../event/EventCard.vue";
import ContactModal from "../contact/ContactModal.vue";
import {
	TextTokens,
	settings,
	DEBUG
} from "@/loader";

@Component({
	components: {
		EventCard,
		ContactModal,
		CertificateContactEdit,
	}
})
export default class CertificateAbilityEdit extends CertificateEdit {
	public loadMessage = "Chargement du certificat de capacité ...";
	public focused = {
		// fk_contact: false,
		header: false,
		title: false,
		price: false,
		productions: false,
		subcontracting_text: false,
		conclusion: false,
	}

	public invalidFeedbacks = {
		// fk_contact: "Le signataire ne peut pas être vide.",
		header: "L'entête ne peut pas être vide.",
		title: "Le titre ne peut pas être vide.",
		price: "Le prix ne peut pas être vide.",
		productions: "",
		subcontracting_text: "",
		conclusion: "La conclusion ne peut pas être vide.",
	}

	public get states() {
		return {
			// fk_contact: this.focused.fk_contact ? (this.item.datas.fk_contact || 0) > 0 : null,
			header: this.focused.header ? (this.item.datas.header?.length || 0) > 0 : null,
			title: this.focused.title ? (this.item.datas.title?.length || 0) > 0 : null,
			price: this.focused.price ? (this.item.datas.price?.length || 0) > 0 : null,
			productions: this.focused.subcontracting_text ? true : null,
			subcontracting_text: this.focused.subcontracting_text ? true : null,
			conclusion: this.focused.conclusion ? (this.item.datas.conclusion?.length || 0) > 0 : null,
		};
	}

	public replaceTokens() {
		if (!this.item || !this.canEdit) {
			return;
		}

		let t = new TextTokens(this.item.project, null, this.item.datas.contact);

		if (t.hasTokens(settings.model_header)) {
			this.item.datas.header = t.replace(settings.model_header);
			this.focusOn("header");
		}
		if (t.hasTokens(settings.model_title)) {
			DEBUG && console.log({ actual: this.item.datas.title, changed: t.replace(settings.model_title), model: settings.model_title, description: this.item.project?.description });
			this.item.datas.title = t.replace(settings.model_title);
			this.focusOn("title");
		}
		if (t.hasTokens(settings.model_price)) {
			this.item.datas.price = t.replace(settings.model_price);
			this.focusOn("price");
		}
		if (t.hasTokens(settings.model_subcontracting)) {
			this.item.datas.subcontracting.text = t.replace(settings.model_subcontracting);
			this.focusOn("subcontracting_text");
		}
		if (t.hasTokens(settings.model_conclusion)) {
			this.item.datas.conclusion = t.replace(settings.model_conclusion);
			this.focusOn("conclusion");
		}
	}
}
